import React, { useContext, useEffect, useState } from "react";
import {
  IconButton,
  Icon,
  Typography,
  Paper,
  makeStyles,
  CircularProgress,
  Tabs,
  Tab,
} from "@material-ui/core";
import Dock from "react-dock";
import _ from "lodash";

import * as homeAPI from "../../api";
import { useRequestHeaders } from "../../../../core/hooks/useRequestHeaders";
import ChartResolver from "../../../../components/charts/ChartResolver";
import KpiTableDetail from "./KpiTableDetail";
import useDock from "../../../../core/hooks/useDockSize";
import { HTTP_STATUS_UNAUTHORIZED } from "../../../../util/Constants";
import { AuthContext } from "../../../../core/providers/AuthContext";

const TABLE_TYPE = "table";

const commonIconStyles = {
  width: "auto",
  height: "auto",
  padding: 1,
  margin: "0px 5px",
};

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "100%",
    width: "100%",
    backgroundColor: `${theme.palette.content.backgroundColor}`,
    position: "relative",
    padding: "20px 10px",
  },
  closeButton: {
    position: "absolute",
    top: 10,
    left: 10,
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  tabsContainer: {
    width: "100%",
    borderRadius: 10,
    backgroundColor: "#D8D8D822",
    marginTop: 20,
    padding: "0px 10px",
    flexGrow: 1,
  },
  tabPanel: {
    height: "90%",
  },
  tabContent: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    padding: 10,
  },
  listKeyValueContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
  },
  listKeyValueItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    marginBottom: 10,
    borderBottom: "1px solid grey",
  },
  listDetailContainer: {
    flex: "1",
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "flex-start",
    //background: `${theme.palette.content.mainColor}33`,
    //borderRadius: 10,
  },
  labelListKeyValue: {
    width: "20%",
    fontWeight: "bold",
  },
  fetchingProgressContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
      className={classes.tabPanel}
    >
      {value === index && children}
    </div>
  );
}

export default function IndicatorDock(props) {
  const { openDetail, handleDetailDock, kpi, kpiName } = props;
  const classes = useStyles();
  const REQUEST_HEADERS = useRequestHeaders();
  const { dockSize, handleDockSize, isMobileDock } = useDock();
  const { logout } = useContext(AuthContext);

  const [data, setData] = useState(null);
  const [fetching, isFetching] = useState(false);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    if (openDetail) {
      isFetching(true);
      fetchKPIDetail();
    }

    return () => null;
    // eslint-disable-next-line
  }, [openDetail]);

  async function fetchKPIDetail() {
    const response = await homeAPI.getKpiDetail({
      REQUEST_HEADERS,
      kpiName,
    });

    if (response) {
      const { dataResponse, status } = response;
      if (status === HTTP_STATUS_UNAUTHORIZED) {
        logout(true);
      } else {
        setData(dataResponse);
      }
    }

    isFetching(false);
  }

  const handleChangeTab = (event, newTab) => {
    setTab(newTab);
  };

  return (
    <Dock
      position="right"
      isVisible={openDetail}
      size={dockSize}
      onSizeChange={handleDockSize}
      zIndex={999}
    >
      <Paper className={classes.paperContainer}>
        <IconButton
          className={classes.closeButton}
          onClick={() => handleDetailDock(false)}
        >
          <Icon className="fas fa-times" style={commonIconStyles} />
        </IconButton>
        <div className={classes.titleContainer}>
          <Typography variant={isMobileDock ? "body1" : "h5"}>
            {kpi?.nombre_kpi}
          </Typography>
        </div>
        {fetching ? (
          <div className={classes.fetchingProgressContainer}>
            <CircularProgress />
          </div>
        ) : !_.isNil(data) && data.length > 0 ? (
          <div className={classes.tabsContainer}>
            <Tabs
              value={tab}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleChangeTab}
              aria-label="indicators_props"
              variant="scrollable"
              scrollButtons="auto"
            >
              {data.map((d, index) => {
                const { titulo } = d;
                return <Tab key={index} label={titulo} />;
              })}
            </Tabs>
            {data.map((dt, index) => {
              const { listKeyValue, listDetail, tipo_grafico } = dt;

              return (
                <TabPanel key={index} value={tab} index={index}>
                  <div className={classes.tabContent}>
                    <div className={classes.listKeyValueContainer}>
                      {!_.isNil(listKeyValue) &&
                        _.isObject(listKeyValue) &&
                        !_.isEmpty(listKeyValue) &&
                        Object.entries(listKeyValue).map(([k, v]) => {
                          return (
                            <div
                              key={`${k}_${v}`}
                              className={classes.listKeyValueItem}
                            >
                              <Typography className={classes.labelListKeyValue}>
                                {k}:
                              </Typography>
                              <Typography>{v}</Typography>
                            </div>
                          );
                        })}
                    </div>
                    <div className={classes.listDetailContainer}>
                      {TABLE_TYPE === tipo_grafico && !_.isNil(listDetail) ? (
                        <KpiTableDetail
                          listDetail={listDetail}
                          kpi={kpi}
                          refreshDetailList={fetchKPIDetail}
                        />
                      ) : !_.isNil(listDetail) && listDetail.length > 0 ? (
                        <ChartResolver
                          type={tipo_grafico}
                          data={listDetail}
                          kpi={kpi}
                        />
                      ) : null}
                    </div>
                  </div>
                </TabPanel>
              );
            })}
          </div>
        ) : null}
      </Paper>
    </Dock>
  );
}
